import { Box } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import * as yup from "yup";

import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import {
  FormProvider,
  SubmitHandler,
  useForm,
  useFormContext,
} from "react-hook-form";
import { AuthContext } from "../../contexts/AuthContext";
import { IModule } from "../../interfaces/IModule";
import { CONFIG } from "../../services/config";
import { FormInputText } from "../form/FormInputText";
import ActionButtons from "../MyModal/ActionButtons";
import Module from "./module";

export default function AddModule({
  watchDataChange,
  messageError,
  addFormData,
  data,
}: any) {
  const { t } = useTranslation();
  const { tokenHeaders } = useContext(AuthContext);

  const addModule: SubmitHandler<IModule> = async (values) => {
    console.log("values", values);

    try {
      await axios.post(
        `${CONFIG.API_URL}countryModules`,
        {
          moduleName: values.moduleName,
          moduleTitle: values.moduleTitle,
        },
        tokenHeaders,
      );
    } catch (error: any) {
      return messageError(error.response.data.message);
    }
    watchDataChange(t("modules.moduleAdded"));
  };

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm<IModule | any>({
    mode: "onBlur",
    resolver: yupResolver(addFormData),
  });

  const methods = useFormContext();

  return (
    <FormProvider
      {...methods}
      reset={reset}
      register={register}
      control={control}
    >
      <Box component="form" onSubmit={handleSubmit(addModule)}>
        <Module errors={errors} />

        <ActionButtons saveName={t("button.Add")} typeButton="submit" />
      </Box>
    </FormProvider>
  );
}
